export enum MessagingTemplateCreateMethodTypes {
    CREATE_FROM_SCRATCH = "create-from-scratch"
}